import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import ArticleIcon from "@mui/icons-material/Article";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CommentIcon from "@mui/icons-material/Comment";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import EditNotificationsIcon from "@mui/icons-material/EditNotifications";
import EmailIcon from "@mui/icons-material/Email";
import EventSeatIcon from "@mui/icons-material/EventSeat";
import FlagIcon from "@mui/icons-material/Flag";
import HandshakeIcon from "@mui/icons-material/Handshake";
import HistoryIcon from "@mui/icons-material/History";
import HomeIcon from "@mui/icons-material/Home";
import KeyIcon from "@mui/icons-material/Key";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import PaymentIcon from "@mui/icons-material/Payment";
import PersonIcon from "@mui/icons-material/Person";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import RateReviewIcon from "@mui/icons-material/RateReview";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import SendIcon from "@mui/icons-material/Send";
import StorefrontIcon from "@mui/icons-material/Storefront";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import TheaterComedyIcon from "@mui/icons-material/TheaterComedy";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import {
  alpha,
  Avatar,
  Badge,
  Box,
  BoxProps,
  darken,
  Divider,
  IconButton,
  Link,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import {
  getMonogram,
  ListNavigation,
  NavigationMenuItem,
  Spacer,
  Toolbar,
  useDownloadUrl,
} from "common";
import useAccess from "features/profile/useAccess";
import I18n from "i18n";
//@ts-ignore
import { BarChart, PivotTableChart } from "@mui/icons-material";
import Logo from "app/components/Logo/Logo";
import { Permissions, ROLES } from "app/constants";
import { useAppSelector } from "app/hooks";
import useNotifyCount from "features/bookings/useNotifyCount";
import useRefundEligibleCount from "features/bookings/useRefundEligibleCount";
import useWebCommentCount from "features/bookings/useWebCommentCount";
import useInvoiceNeededCount from "features/payment-transactions/useInvoiceNeededCount";
import { selectProfile } from "features/profile/profileSlice";
import WangoghLogo from "wangogh/WangoghLogo";
import AdminUserMenu from "./AdminUserMenu";

export interface GroupProps extends BoxProps {
  open?: boolean;
}

export interface AdminSidebarMenuProps {
  open?: boolean;
  temporary?: boolean;
  setOpen?: (open?: boolean) => void;
}
export default function AdminSidebarMenu({
  open,
  setOpen,
  temporary,
}: AdminSidebarMenuProps) {
  const theme = useTheme();
  const profile = useAppSelector(selectProfile);
  const { hasPermissions, hasRoles, notHasRoles } = useAccess();
  const { downloadUrl } = useDownloadUrl();
  const invoiceNeededCount = useInvoiceNeededCount();
  const notifyCount = useNotifyCount();
  const webCommentCount = useWebCommentCount();
  const refundEligibleCount = useRefundEligibleCount();
  return (
    <Paper
      className={"AppSidebarWrapper"}
      /*sx={
        temporary
          ? {
              flex: 1,
              display: "flex",
              flexDirection: "column",
              color: theme => theme.palette.common.white,
              backgroundColor: theme =>
                theme.palette.mode === "dark"
                  ? theme.palette.background.paper
                  : theme.palette.primary.main,
            }
          : {
              flex: 1,
              display: "flex",
              flexDirection: "column",
              color: theme => theme.palette.common.white,
              borderRadius: theme => theme.shape.borderRadius / 3,
              backgroundColor: theme =>
                theme.palette.mode === "dark"
                  ? theme.palette.background.paper
                  : theme.palette.primary.main,
              m: 2,
            }
      }*/
    >
      {!temporary && (
        <>
          <Box
            sx={{
              p: 2,
              overflow: "hidden",
            }}
          >
            <Toolbar sx={{ width: "fit-content" }}>
              <Logo size={40} />
              {open && (
                <>
                  <Spacer w={2} />
                  <Typography
                    variant="h6"
                    sx={{ display: open ? "block" : "none" }}
                  >
                    {I18n.t("App.title")}
                  </Typography>
                </>
              )}
            </Toolbar>
          </Box>
          <Divider />
        </>
      )}
      <ListNavigation minimized={!open} pattern="/">
        {hasPermissions(Permissions.CalendarMenu) && (
          <NavigationMenuItem
            label={I18n.t("Home.title")}
            value=""
            absolute
            icon={<HomeIcon />}
          />
        )}
      </ListNavigation>
      <ListNavigation
        grouped
        groupTitle={"Foglalások".substring(0, open ? undefined : 1)}
        minimized={!open}
        pattern="/"
        open
      >
        {hasPermissions("booking.menu") && (
          <NavigationMenuItem
            label={I18n.t("Booking.title")}
            value="bookings"
            icon={<KeyIcon />}
          />
        )}
        {hasPermissions("booking.menu") && (
          <NavigationMenuItem
            label={I18n.t("Booking.shouldNotifyTitle")}
            value="notify-bookings"
            icon={
              <Badge badgeContent={notifyCount} color="error">
                <PublishedWithChangesIcon />
              </Badge>
            }
          />
        )}
        {hasPermissions("booking.menu") && (
          <NavigationMenuItem
            label={I18n.t("Booking.webCommentTitle")}
            value="web-comment-bookings"
            icon={
              <Badge badgeContent={webCommentCount} color="error">
                <CommentIcon />
              </Badge>
            }
          />
        )}
        {hasPermissions("booking.menu") && (
          <NavigationMenuItem
            label={I18n.t("Booking.refundEligibleTitle")}
            value="refund-eligible-bookings"
            icon={
              <Badge badgeContent={refundEligibleCount} color="error">
                <MoneyOffIcon />
              </Badge>
            }
          />
        )}
        {hasPermissions("booking_document.menu") && (
          <NavigationMenuItem
            label={I18n.t("BookingDocument.title")}
            value="booking-documents"
            icon={<ArticleIcon />}
          />
        )}
      </ListNavigation>
      <ListNavigation minimized={!open} pattern="/">
        {hasPermissions(Permissions.KitchenMenu) && (
          <NavigationMenuItem
            label={I18n.t("Kitchen.title")}
            value="kitchen"
            icon={<RestaurantMenuIcon />}
          />
        )}
        {hasPermissions(Permissions.CateringMenu) && (
          <NavigationMenuItem
            label={I18n.t("Catering.title")}
            value="catering"
            icon={<EventSeatIcon />}
          />
        )}
        {hasPermissions(Permissions.HostMenu) && (
          <NavigationMenuItem
            label={I18n.t("Host.title")}
            value="host"
            icon={<SupportAgentIcon />}
          />
        )}
        {hasPermissions(Permissions.StreetMenu) && (
          <NavigationMenuItem
            label={I18n.t("StreetSales.title")}
            value="street-sales"
            icon={<StorefrontIcon />}
          />
        )}
        {hasPermissions("event.menu") && (
          <NavigationMenuItem
            label={I18n.t("Event.title")}
            value="events"
            icon={<CalendarMonthIcon />}
          />
        )}
      </ListNavigation>
      {hasPermissions([
        "report.menu_advanced",
        "report.menu_simple",
        "report.menu_sales",
        "report.menu_controlling",
        "report.menu_commission",
        "report.menu_coordinator",
        "report.menu_coordinator_street",
        "report.menu_coordinator_web",
        "report.menu_daily_trips",
      ]) && (
        <ListNavigation
          grouped
          groupTitle={"Riportok".substring(0, open ? undefined : 1)}
          minimized={!open}
          pattern="/reports"
        >
          {hasPermissions("report.menu_simple") && (
            <NavigationMenuItem
              label={I18n.t("SimpleReport.title")}
              value="simple"
              to="/reports/simple"
              icon={<BarChart />}
            />
          )}
          {hasPermissions("report.menu_controlling") && (
            <NavigationMenuItem
              label={I18n.t("PivotReport.title")}
              value="controlling"
              to="/reports/controlling"
              icon={<PivotTableChart />}
            />
          )}
          {hasPermissions("report.menu_advanced") && (
            <NavigationMenuItem
              label={I18n.t("AdvancedReport.title")}
              value="advanced"
              to="/reports/advanced"
              icon={<BarChart />}
            />
          )}
          {hasPermissions("report.menu_sales") && (
            <NavigationMenuItem
              label={I18n.t("SalesReport.title")}
              value="sales"
              to="/reports/sales"
              icon={<BarChart />}
            />
          )}
          {hasPermissions("report.menu_coordinator") && (
            <NavigationMenuItem
              label={I18n.t("CoordinatorReport.title")}
              value="coordinator"
              to="/reports/coordinator"
              icon={<BarChart />}
            />
          )}
          {hasPermissions("report.menu_coordinator_street") && (
            <NavigationMenuItem
              label={I18n.t("CoordinatorReport2.title")}
              value="coordinator-2"
              to="/reports/coordinator-2"
              icon={<BarChart />}
            />
          )}
          {hasPermissions("report.menu_coordinator_web") && (
            <NavigationMenuItem
              label={I18n.t("CoordinatorReport3.title")}
              value="coordinator-3"
              to="/reports/coordinator-3"
              icon={<BarChart />}
            />
          )}
          {hasPermissions("report.menu_daily_trips") && (
            <NavigationMenuItem
              label={I18n.t("DailyTripsReport.title")}
              value="daily-trips"
              to="/reports/daily-trips"
              icon={<BarChart />}
            />
          )}
          {hasPermissions("report.menu_commission") && (
            <NavigationMenuItem
              label={I18n.t("CommissionReport.title")}
              value="/reports/commission"
              icon={<AssessmentIcon />}
            />
          )}
        </ListNavigation>
      )}
      {hasPermissions([
        "seating_layout.menu",
        "partner_group.menu",
        "program.menu",
        "option_group.menu",
        "boat.menu",
        "schedule.menu",
        "sales_person.menu",
        "partner.menu",
        "exchange_rate.menu",
        "payment_transaction.menu",
        "review_email_sent.menu",
      ]) && (
        <ListNavigation
          grouped
          groupTitle={"Admin".substring(0, open ? undefined : 1)}
          minimized={!open}
          pattern="/"
        >
          {hasPermissions("seating_layout.menu") && (
            <NavigationMenuItem
              label={I18n.t("SeatingLayout.title")}
              value="seating-layouts"
              icon={<EventSeatIcon />}
            />
          )}
          {hasPermissions("redflag_partner.menu") && (
            <NavigationMenuItem
              label={I18n.t("RedflagPartner.title")}
              value="redflag-partners"
              icon={<FlagIcon color="error" />}
            />
          )}
          {hasPermissions("partner_group.menu") && (
            <NavigationMenuItem
              label={I18n.t("PartnerGroup.title")}
              value="partner-groups"
              icon={<WorkspacesIcon />}
            />
          )}
          {hasPermissions("partner_feed.menu") && (
            <NavigationMenuItem
              label={I18n.t("PartnerFeed.title")}
              value="partner-feeds"
              icon={<RssFeedIcon />}
            />
          )}
          {false && hasPermissions("review_partner.menu") && (
            <NavigationMenuItem
              label={I18n.t("ReviewPartner.title")}
              value="review-partners"
              icon={<RateReviewIcon />}
            />
          )}
          {hasPermissions("program.menu") && (
            <NavigationMenuItem
              label={I18n.t("Program.title")}
              value="programs"
              icon={<TheaterComedyIcon />}
            />
          )}
          {hasPermissions("option_group.menu") && (
            <NavigationMenuItem
              label={I18n.t("OptionGroup.title")}
              value="option-groups"
              icon={<WorkspacesIcon />}
            />
          )}
          {hasPermissions("boat.menu") && (
            <NavigationMenuItem
              label={I18n.t("Boat.title")}
              value="boats"
              icon={<DirectionsBoatIcon />}
            />
          )}
          {hasPermissions("schedule.menu") && (
            <NavigationMenuItem
              label={I18n.t("Schedule.title")}
              value="schedules"
              icon={<EditCalendarIcon />}
            />
          )}
          {hasPermissions("partner.menu") && (
            <NavigationMenuItem
              label={I18n.t("Partner.title")}
              value="partners"
              icon={<HandshakeIcon />}
            />
          )}
          {hasPermissions("sales_person.menu") && (
            <NavigationMenuItem
              label={I18n.t("SalesPerson.title")}
              value="sales-persons"
              icon={<LoyaltyIcon />}
            />
          )}
          {hasPermissions("exchange_rate.menu") && (
            <NavigationMenuItem
              label={I18n.t("ExchangeRate.title")}
              value="exchange-rates"
              icon={<CurrencyExchangeIcon />}
            />
          )}
          {hasPermissions("payment_transaction.menu") && (
            <NavigationMenuItem
              label={I18n.t("PaymentTransaction.title")}
              value="payment-transactions"
              icon={
                <Badge badgeContent={invoiceNeededCount} color="error">
                  <PaymentIcon />
                </Badge>
              }
            />
          )}
          {
            //hasPermissions("review_email_sent.menu") && (
            hasPermissions("review_partner.menu") && (
              <NavigationMenuItem
                label={I18n.t("ReviewEmailSent.title")}
                value="review-email-sents"
                icon={<EmailIcon />}
              />
            )
          }
          {hasPermissions("email_template.menu") && (
            <NavigationMenuItem
              label={I18n.t("EmailTemplate.title")}
              value="email-templates"
              icon={<EmailIcon />}
            />
          )}
          {hasPermissions("bulk_email_sent.menu") && (
            <NavigationMenuItem
              label={I18n.t("BulkEmailSent.title")}
              value="bulk-emails-sent"
              icon={<SendIcon />}
            />
          )}
        </ListNavigation>
      )}
      {hasRoles([ROLES.SUPERADMIN]) && (
        <ListNavigation
          grouped
          groupTitle={"SuperAdmin".substring(0, open ? undefined : 1)}
          minimized={!open}
          pattern="/"
        >
          {hasPermissions(["user.viewown", "user.viewany"]) && (
            <NavigationMenuItem
              label={I18n.t("User.title")}
              value="users"
              icon={<PersonIcon />}
            />
          )}
          {hasPermissions("role.view") && (
            <NavigationMenuItem
              label={I18n.t("Role.title")}
              value="roles"
              icon={<AdminPanelSettingsIcon />}
            />
          )}
          {hasPermissions(["history.viewany", "history.viewown"]) && (
            <NavigationMenuItem
              label={I18n.t("History.title")}
              value="history"
              icon={<HistoryIcon />}
            />
          )}
          {hasPermissions(["file.view"]) && (
            <NavigationMenuItem
              label={I18n.t("File.title")}
              value="files"
              icon={<AttachFileIcon />}
            />
          )}
          {hasPermissions("email_template.viewany") && (
            <NavigationMenuItem
              label={I18n.t("EmailPreview.title")}
              value="email-preview"
              icon={<MarkEmailReadIcon />}
            />
          )}
          {hasPermissions([
            "notification_address.viewown",
            "notification_address.viewany",
          ]) && (
            <NavigationMenuItem
              label={I18n.t("NotificationAddress.title")}
              value="notification-addresses"
              icon={<EditNotificationsIcon />}
            />
          )}
        </ListNavigation>
      )}
      <Box flex={1}></Box>
      <Box sx={{ padding: 1 }}>
        <Toolbar
          sx={{
            justifyContent: open ? "flex-end" : "center",
            paddingBottom: 2,
          }}
        >
          <IconButton
            onClick={() => setOpen && setOpen(!open)}
            color="inherit"
            sx={{
              backgroundColor: theme =>
                theme.palette.mode === "light"
                  ? "rgba(255,255,255,0.1)"
                  : theme.palette.action.hover,
              "&:hover": {
                backgroundColor: theme =>
                  theme.palette.mode === "light"
                    ? "rgba(255,255,255,0.2)"
                    : theme.palette.action.selected,
              },
            }}
          >
            {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </Toolbar>
        <Toolbar
          sx={{
            marginLeft: theme.spacing(1),
          }}
        >
          <Avatar
            sx={{
              backgroundColor: theme => alpha(theme.palette.primary.dark, 0.6),
              color: "white",
            }}
            src={profile.file_id ? downloadUrl(profile.file_id) : undefined}
          >
            {getMonogram(profile)}
          </Avatar>
          {open && (
            <>
              <Spacer w={1} />
              <Box>
                <Typography variant="body2">
                  {profile.last_name} {profile.first_name}
                </Typography>
                <Typography
                  variant="body2"
                  fontSize={10}
                  sx={{
                    color: theme => theme.palette.text.secondary,
                  }}
                >
                  {profile.roles?.join(",")}
                </Typography>
              </Box>
              <Spacer right />
              {<AdminUserMenu />}
            </>
          )}
        </Toolbar>
      </Box>
      <Divider />
      <Spacer h={1} />
      <Toolbar
        sx={{
          paddingLeft: 1,
          paddingRight: 2,
          paddingTop: 0,
          paddingBottom: 0.5,
        }}
      >
        <Spacer right />
        <Link
          component="a"
          href="https://www.wangoghsoft.com"
          target="_blank"
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            color: theme => darken(theme.palette.primary.dark, 0.4),
            textDecoration: "none",
          }}
        >
          {open && (
            <>
              <Typography variant="body2" fontSize={10}>
                created by
              </Typography>
              <Spacer w={1} />
            </>
          )}
          <WangoghLogo sx={{ width: 36 }} typo={false} />
        </Link>
      </Toolbar>
    </Paper>
  );
}
